export default __webpack_public_path__ + "static/media/img-5.b2a1087b.jpg";